import { render, staticRenderFns } from "./history_turnover.vue?vue&type=template&id=62f3803f&scoped=true&"
import script from "./history_turnover.vue?vue&type=script&lang=js&"
export * from "./history_turnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3803f",
  null
  
)

export default component.exports